import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { EventAgendaTimeslot } from 'src/modules/events/models';
import { EventPageAgendaTimeslotSpeakers } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotSpeakers';
import { EventPageAgendaTimeslotDate } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDate';
import { EventPageAgendaTimeslotDescription } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDescription';
import { EventPageAgendaTimeslotDetails } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDetails';

export interface EventPageAgendaTimeslotProps {
  timeslot: EventAgendaTimeslot;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
  isChecked: boolean;
  toggleIsChecked: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  padding: 32px 0;
  border-bottom: 1px solid ${({ theme }) => theme.skeleton.base};

  ${media.w.lessThan.desktop} {
    flex-direction: column;

    padding: 16px 0;
  }
`;

const ContentColumn = styled.div`
  position: relative;
  width: 100%;
  ${media.w.lessThan.desktop} {
    padding-right: 20px;
  }
`;

export const EventPageAgendaTimeslot = ({
  timeslot,
  isExpanded,
  toggleIsExpanded,
  isChecked,
  toggleIsChecked,
}: EventPageAgendaTimeslotProps) => {
  return (
    <Container>
      <EventPageAgendaTimeslotDate
        startDate={timeslot.startDate}
        endDate={timeslot.endDate}
      />

      <ContentColumn>
        <EventPageAgendaTimeslotDetails
          timeslot={timeslot}
          isChecked={isChecked}
          toggleIsChecked={toggleIsChecked}
        />
        <EventPageAgendaTimeslotSpeakers speakers={timeslot.speakers} />

        {timeslot.description && (
          <EventPageAgendaTimeslotDescription
            description={timeslot.description}
            isExpanded={isExpanded}
            toggleIsExpanded={toggleIsExpanded}
          />
        )}
      </ContentColumn>
    </Container>
  );
};
